<template>
  <div>
    <Modal
      v-model="modal"
      :title="
        !redisWarningForm.id
          ? this.$t('DocDBMonitor.addRedshift')
          : this.$t('DocDBMonitor.editRedshift')
      "
      @on-cancel="cancel"
      @on-ok="ok"
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      width="800px"
      :footer-hide="true"
      :closable="false"
    >
      <Form
        ref="redisWarningForm"
        :model="redisWarningForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning
            v-if="wechatWarningVisible"
            ref="wechatWarning"
          ></wechat-warning>
          <!-- 规则名称 -->
          <FormItem
            :label="$t('alarms.common.ruleName')"
            prop="ruleName"
            v-if="isEditRuleName"
          >
            <Row>
              <Col span="11">
                <Input
                  type="text"
                  v-model="redisWarningForm.ruleName"
                  placeholder="Enter something..."
                  style="width: 300px"
                  :disabled="isEdit"
                ></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{ this.redisWarningForm.ruleName }}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="6">
                <FormItem prop="monitorIndex">
                  <Select
                    v-model="redisWarningForm.monitorIndex"
                    @on-change="
                      changeMonitorIndex(redisWarningForm.monitorIndex)
                    "
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="item in monitorIndexList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select
                    v-model="redisWarningForm.cycle"
                    :placeholder="$t('alarms.common.cycle')"
                    @on-change="changeCycle(redisWarningForm.cycle)"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in cycleList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select
                    v-model="redisWarningForm.continousCycle"
                    :placeholder="$t('alarms.common.continuousCycle')"
                    @on-change="
                      changeContinousCycle(redisWarningForm.continousCycle)
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in continousCycleList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="3">
                <FormItem prop="statisticsValue">
                  <Select
                    v-model="redisWarningForm.statisticsValue"
                    :placeholder="$t('alarms.common.statisticsValue')"
                    @on-change="
                      changeStatisticsValue(redisWarningForm.statisticsValue)
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in statisticsValueList"
                      v-bind:key="index"
                    >
                      {{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <div v-if="this.isShowField">
                <!-- 关系符号 -->
                <Col span="2">
                  <FormItem prop="relationshipSign">
                    <Select
                      v-model="redisWarningForm.relationshipSign"
                      @on-change="
                        changeRelationshipSign(
                          redisWarningForm.relationshipSign
                        )
                      "
                      :placeholder="$t('alarms.common.symbol')"
                    >
                      <Option
                        :value="item.id"
                        v-for="(item, index) in relationshipSignList"
                        v-bind:key="index"
                        >{{ item.name }}</Option
                      >
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input
                      v-model="redisWarningForm.thresholdValue"
                      :placeholder="$t('alarms.common.threshold')"
                      type="number"
                    ></Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input
                      v-model="redisWarningForm.unit"
                      disabled
                      :placeholder="$t('alarms.common.unit')"
                    ></Input>
                  </FormItem>
                </Col>
              </div>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
            <RadioGroup
              v-model="redisWarningForm.contactType"
              @on-change="changeContactType(redisWarningForm.contactType)"
            >
              <Radio
                v-for="item in contactTypeList"
                :label="item.type"
                :key="item.value"
                >{{ item.label }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem
            :label="$t('alarms.common.notificationObject')"
            prop="notificationObject"
            v-if="redisWarningForm.contactType == 0"
          >
            <Select
              v-model="redisWarningForm.notificationObject"
              multiple
              style="width: 300px"
              @on-change="changeNotificationObject"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in notificationObjectList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem
            :label="$t('alarms.common.contactGroup')"
            prop="contactGroupIds"
            v-if="redisWarningForm.contactType == 1"
          >
            <Select
              v-model="redisWarningForm.contactGroupIds"
              multiple
              style="width: 300px"
              @on-change="
                changeContactGroupId(redisWarningForm.contactGroupIds)
              "
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in contactGroupIdList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select
              v-model="redisWarningForm.noticeType"
              multiple
              style="width: 300px"
              @on-change="selectNoticeType(redisWarningForm.noticeType)"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmWayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem
            :label="$t('alarms.common.enterpriseWeChatRobotURL')"
            prop="enterpriseWechatRobotIds"
            v-if="
              redisWarningForm.noticeType.filter(function(e) {
                return e == 3;
              }).length != 0
            "
          >
            <Select
              v-model="redisWarningForm.enterpriseWechatRobotIds"
              multiple
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in enterpriseWechatRobotIdsList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select
              v-model="redisWarningForm.alarmDelay"
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmDelayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem
            :label="$t('alarms.common.monitorPeriod')"
            prop="monitorPeriod"
          >
            <Select
              v-model="redisWarningForm.monitorPeriod"
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in monitorPeriodList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input
                v-model="redisWarningForm.emailModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem
              :label="$t('alarms.common.wechatModal')"
              prop="wechatModal"
            >
              <Input
                v-model="redisWarningForm.wechatModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              style="float: right"
              @click="ok('redisWarningForm')"
              :loading="addloading"
              :disabled="isAddOrEdit"
              >{{
                !redisWarningForm.id
                  ? this.$t("common.addAlarm")
                  : this.$t("common.editAlarm")
              }}
            </Button>
            <Button
              size="large"
              style="float: right; margin-right: 10px"
              @click="cancel('redisWarningForm')"
              >{{ $t("alarms.common.cancel") }}</Button
            >
            <Button
              size="large"
              @click="previousPage"
              style="float: right; margin-right: 10px"
              >{{ $t("alarms.common.lastStep") }}</Button
            >
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="6">
                <!-- 账户 -->
                <FormItem
                  :label="$t('alarms.common.account')"
                  prop="account"
                  :label-width="50"
                >
                  <Select
                    v-model="redisWarningForm.account"
                    @on-change="changeAccount(redisWarningForm.account)"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in accountList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="10" style="z-index: 200">
                <!-- 存储区域 -->
                <FormItem
                  :label="$t('alarms.common.region')"
                  prop="backupRegion"
                >
                  <Select
                    @on-change="
                      changebackupRegion(redisWarningForm.backupRegion)
                    "
                    v-model="redisWarningForm.backupRegion"
                    multiple
                    :max-tag-count="1"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Checkbox
                      v-model="singleBackupRegion"
                      @on-change="selectBackupRegionAll"
                      style="display: block; text-align: right"
                      >{{ $t("alarms.common.allSelected") }}</Checkbox
                    >
                    <Option
                      :value="item.name"
                      v-for="item in backupRegionList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="6">
                <Select v-model="roleName">
                  <Option
                    v-for="t in typeList"
                    :value="t.name"
                    :key="t.name"
                    :label="t.name"
                  ></Option>
                </Select>
              </Col>
              <Button
                type="primary"
                style="float: right"
                v-show="isShowSearch"
                @click="searchRedisDate"
                >{{ $t("alarms.common.search") }}</Button
              >
            </Row>
          </div>

          <v-table
            :height="459"
            column-width-drag
            is-horizontal-resize
            style="width: 100%; height: 459px; margin-bottom: 15px"
            :columns="column"
            :table-data="tableRedisDate"
            row-hover-color="#edf7ff"
            :is-loading="modal_loadings"
            title-bg-color="#f8f8f9"
            :select-group-change="selectChange"
            :select-all="selectAll"
          >
            <!-- <template slot-scope="{ row, index }" slot="Identifier">
              <p>
                ces
                {{
                  this.roleName == "集群"
                    ? scope.row.dbClusterIdentifier
                    : scopr.row.dbInstanceIdentifier
                }}
              </p>
            </template> -->
          </v-table>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              @click="nextPage"
              style="float: right"
              :disabled="isNextClick"
              >{{ $t("alarms.common.nextStep") }}
            </Button>
            <Button
              size="large"
              style="margin-right: 10px; float: right"
              @click="cancel('redisWarningForm')"
              >{{ $t("alarms.common.cancel") }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import WechatWarning from "../common/WechatWarning.vue";
import { setCookie, getCookie } from "@/utils/cookieUtil.js";
import TableRedis from "./TableRedis.vue";

var tableRedis = TableRedis;
var tableRedisWarningVue = {};
export default {
  inject: ["reload"],
  components: {
    WechatWarning
  },
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.alertRule
        .nameRepeatedCheck({
          alertRuleName: this.redisWarningForm.ruleName,
          monitorModule: this.monitorModule
        })
        .then(res => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch(err => {
          if (err.status == 400) {
            callback(new Error("规则名称不能重复!"));
          }
        });
    };
    return {
      roleName: "集群",
      editRoleName: "",
      type: "0",
      typeList: [
        { name: "集群", id: 0 },
        { name: "实例", id: 1 }
      ],
      monitorModule: 5,
      isAddOrEdit: true,
      wechatWarningVisible: false,
      contactTypeList: [
        {
          label: this.$t("alarms.common.contactPerson"),
          value: "contact",
          type: 0
        },
        {
          label: this.$t("alarms.common.contactGroup"),
          value: "contactGroup",
          type: 1
        }
      ],
      isShowField: true, //是否显示符号、阈值和单位
      addloading: false,
      singleBackupRegion: false,
      alarmDelayList: [],
      monitorPeriodList: [],
      isEdit: false,
      isShowSearch: false,
      isEditRuleName: false,
      showRuleName: false,
      modal_loadings: false,
      isShowEmail: false,
      isShowWeChat: false,
      isNext: false,
      isPrevious: true,
      selection: [],
      accountList: [],
      notificationObjectList: [],
      alarmWayList: [],
      backupRegionList: [],
      loading: true,
      modal: false,
      modal_loading: false,
      exportDataList: "",
      noticeType: [],
      units: "",
      isNextClick: true, //禁止点击下一步
      unit: "",
      redisWarningForm: {
        account: "",
        ruleName: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        thresholdValue: "",
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        relationshipSign: "",
        unit: "",
        backupRegion: [],
        alarmDelay: "",
        monitorPeriod: "",
        contactType: 0,
        contactGroupIds: [],
        userIdList: [],
        enterpriseWechatRobotIds: []
      },
      enterpriseWechatRobotIdsList: [],
      // 联系人组
      contactGroupIdList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 关系符号
      relationshipSignList: [],
      ruleValidate: {
        account: [
          {
            required: true,
            message: "请选择账户名称",
            trigger: "change",
            type: "number"
          }
        ],
        alarmDelay: [
          {
            required: true,
            message: "请选择延迟告警",
            trigger: "change",
            type: "number"
          }
        ],
        monitorPeriod: [
          {
            required: true,
            message: "请选择监控时段",
            trigger: "change",
            type: "number"
          }
        ],
        backupRegion: [
          {
            required: true,
            type: "array",
            message: "请选择存储区域",
            trigger: "change"
          }
        ],
        ruleName: [
          { required: true, message: "规则名称不能为空", trigger: "blur" },
          {
            type: "string",
            message: "规则名称为2-20个字符首尾中间不能有空格",
            pattern: "^[^ ]{2,20}$",
            trigger: "blur"
          },
          { validator: validNameRepeatedCheck, trigger: "blur" }
        ],
        notificationObject: [
          {
            required: true,
            type: "array",
            message: "请选择通知对象",
            trigger: "change"
          }
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: "请选择报警方式",
            trigger: "change"
          }
        ],
        monitorIndex: [
          {
            required: true,
            message: "请选择监控指标",
            trigger: "change",
            type: "number"
          }
        ],
        cycle: [
          {
            required: true,
            message: "请选择周期",
            trigger: "change",
            type: "number"
          }
        ],
        continousCycle: [
          {
            required: true,
            message: "请选择连续周期",
            trigger: "change",
            type: "number"
          }
        ],
        statisticsValue: [
          {
            required: true,
            message: "请选择统计数值",
            trigger: "change",
            type: "number"
          }
        ],
        relationshipSign: [
          {
            required: true,
            message: "请选择关系符号",
            trigger: "change",
            type: "number"
          }
        ],
        thresholdValue: [{ required: true, message: "请输入阈值" }],
        contactType: [
          {
            required: true,
            message: "请选择联系方式",
            trigger: "change",
            type: "number"
          }
        ],
        contactGroupIds: [
          {
            required: true,
            message: "请选择联系人组",
            trigger: "change",
            type: "array"
          }
        ],
        enterpriseWechatRobotIds: [
          {
            required: true,
            type: "array",
            message: "请选择企业微信机器人URL",
            trigger: "change"
          }
        ]
      },
      column: [
        {
          width: 60,
          titleAlign: "center",
          columnAlign: "center",
          type: "selection"
        },
        {
          field: "dbClusterIdentifier",
          title: this.$t("DocDBMonitor.ClusterIdentifier"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "dbInstanceIdentifier",
          title: this.$t("DocDBMonitor.instanceIdentifier"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "roleName",
          title: this.$t("DocDBMonitor.roleName"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "engineVersion",
          title: this.$t("DocDBMonitor.engineVersion"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "status",
          title: this.$t("DocDBMonitor.status"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "region",
          title: this.$t("DocDBMonitor.region"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        }
      ],
      tableRedisDate: [],
      newTableRedisDateList: [],
      redisList: [],
      compareRedisList: [],
      compareDocDBList: []
    };
  },

  beforeCreate: function() {
    tableRedisWarningVue = this;
  },
  methods: {
    //显示表格数据
    /****************************************************************/
    // 下一步
    nextPage: function() {
      this.isNext = true;
      this.isPrevious = false;
      // 查询监控指标
      tableRedisWarningVue.searchMonitorIndex();
      // 查询阈值
      tableRedisWarningVue.selectMonitorIndexDefault();
      // 查询联系人组
      tableRedisWarningVue.listContactGroups();
    },
    // 上一步
    previousPage: function() {
      this.isNext = false;
      this.isPrevious = true;
    },
    init: function(id) {
      this.redisWarningForm.id = id || 0;
      // 根据用户名查询Account列表
      tableRedisWarningVue.getAccount();
      this.$nextTick(() => {
        // 重置表单
        this.$refs["redisWarningForm"].resetFields();
        // 编辑
        if (this.redisWarningForm.id) {
          // 编辑显示不能输入的规则名称
          this.showRuleName = true;
          this.isEdit = true;
          this.isShowSearch = false;
          this.$api.alertRule
            .selectAlertRule("id", this.redisWarningForm.id)
            .then(res => {
              this.editRoleName = res.data.roleName;
              this.roleName = res.data.roleName;
              //延时
              this.redisWarningForm.alarmDelay = res.data.delay;
              //监控时段
              this.redisWarningForm.monitorPeriod = res.data.monitorPeriod;
              // 账户
              /******************************************************/
              this.redisWarningForm.account = res.data.accountId;
              tableRedisWarningVue.$api.account
                .queryAccountRegions("accountId", this.redisWarningForm.account)
                .then(res => {
                  this.backupRegionList = res.data;
                });

              tableRedisWarningVue.$api.contact
                .queryContactsByAccountIdAndMonitorModule({
                  monitorModule: this.monitorModule,
                  accountId: this.redisWarningForm.account
                })
                .then(res => {
                  this.notificationObjectList = res.data.contactList;
                });

              this.modal_loadings = true;

              setTimeout(() => {
                // 存储区域
                this.redisWarningForm.backupRegion = res.data.regions;

                // redis列表
                /******************************************************/
                // this.redisList = res.data.resourceAwsCacheDTOList;

                // this.compareRedisList = res.data.resourceAwsCacheDTOList;
                // 根据接口返回的roleName做判断
                if (this.editRoleName == "集群") {
                  // this.redisList = res.data.docDbClusterDTOList;
                  this.compareRedisList = res.data.docDbClusterDTOList;
                } else {
                  // 实例
                  // this.redisList = res.data.docDbInstanceDTOList;
                  this.compareDocDBList = res.data.docDbInstanceDTOList;
                }
                // 根据AccountId查询es列表
                tableRedisWarningVue.$api.DocDB.queryAwsDocDbClusters({
                  regions: this.redisWarningForm.backupRegion,
                  accountId: this.redisWarningForm.account,
                  roleName: this.roleName
                }).then(res => {
                  // 1. 判断是集群 还是 实例
                  // 2. 数组循环对比 选中数据
                  this.tableRedisDate = res.data;
                  this.monitorModule = res.data[0].monitorModule;
                  this.modal_loadings = false;
                  // 根据后端返回 roleName 判断
                  if (this.editRoleName == "集群") {
                    for (var i = 0; i < this.tableRedisDate.length; i++) {
                      for (var j = 0; j < this.compareRedisList.length; j++) {
                        // 集群数据勾选
                        if (
                          this.tableRedisDate[i].dbClusterIdentifier ==
                          this.compareRedisList[j].dbClusterIdentifier
                        ) {
                          this.tableRedisDate[i]._checked = true;
                        }
                      }
                    }
                  } else {
                    for (var i = 0; i < this.tableRedisDate.length; i++) {
                      for (var j = 0; j < this.compareDocDBList.length; j++) {
                        // 实例数据勾选
                        if (
                          this.tableRedisDate[i].dbInstanceIdentifier ==
                          this.compareDocDBList[j].dbInstanceIdentifier
                        ) {
                          this.tableRedisDate[i]._checked = true;
                        }
                      }
                    }
                  }

                  // 选了数据 可以点击下一步
                  if (this.editRoleName == "集群") {
                    if (
                      this.tableRedisDate.length == 0 ||
                      this.compareRedisList.length == 0
                    ) {
                      this.isNextClick = true;
                    } else {
                      this.isNextClick = false;
                    }
                  } else {
                    if (
                      this.tableRedisDate.length == 0 ||
                      this.compareDocDBList.length == 0
                    ) {
                      this.isNextClick = true;
                    } else {
                      this.isNextClick = false;
                    }
                  }
                });
              }, 1000);
              // 根据rolename判断
              if (this.editRoleName == "集群") {
                this.newTableRedisDateList = res.data.docDbClusterDTOList;
              } else {
                this.newTableRedisDateList = res.data.docDbInstanceDTOList;
              }
              // this.newTableRedisDateList = res.data.resourceAwsCacheDTOList;

              // 规则名称
              this.redisWarningForm.ruleName = res.data.alertRuleName;

              // 监控指标
              /******************************************************/
              this.redisWarningForm.monitorIndex = res.data.monitorIndex;
              // 判断状态
              this.judgeState();
              // 周期
              this.redisWarningForm.cycle = res.data.cycle;
              // 连续周期
              this.redisWarningForm.continousCycle = res.data.continousCycle;
              // 统计数值
              this.redisWarningForm.statisticsValue = res.data.statisticsValue;
              // 符号
              this.redisWarningForm.relationshipSign =
                res.data.relationshipSign;
              // 阈值
              this.redisWarningForm.thresholdValue = res.data.thresholdValue;
              // 单位
              this.redisWarningForm.unit = res.data.unit;
              this.units = res.data.unitId;
              // 企业微信机器人URL
              // this.redisWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

              // 联系方式
              this.redisWarningForm.contactType = res.data.contactType;
              if (res.data.contactType == 0) {
                // 通知对象
                this.redisWarningForm.notificationObject = res.data.contactIDs;
                for (
                  var i = 0;
                  i < this.redisWarningForm.notificationObject.length;
                  i++
                ) {
                  for (var j = 0; j < this.notificationObjectList.length; j++) {
                    if (
                      this.redisWarningForm.notificationObject[i] ==
                      this.notificationObjectList[j].id
                    ) {
                      this.redisWarningForm.userIdList.push(
                        this.notificationObjectList[j].userId
                      ); //传值
                    }
                  }
                }
              } else if (res.data.contactType == 1) {
                // 联系人组
                this.$api.contactGroup
                  .listContactGroupsByAccountId(
                    "accountId",
                    this.redisWarningForm.account
                  )
                  .then(res => {
                    this.contactGroupIdList = res.data;
                  });
                setTimeout(() => {
                  this.redisWarningForm.contactGroupIds =
                    res.data.contactGroupIds;
                }, 1000);
              }

              // 报警方式
              this.redisWarningForm.noticeType = res.data.noticeType;
              // 循环邮件模板
              for (
                let i = 0;
                i < this.redisWarningForm.noticeType.length;
                i++
              ) {
                if (this.redisWarningForm.noticeType[i] === 0) {
                  this.isShowEmail = true;
                  this.redisWarningForm.emailModal =
                    res.data.briefReportBodyMail;
                  this.noticeType = this.redisWarningForm.noticeType;
                  tableRedisWarningVue.selectTemplate();
                }
                if (this.redisWarningForm.noticeType[i] === 1) {
                  this.isShowWeChat = true;
                  this.redisWarningForm.wechatModal =
                    res.data.briefReportBodyWechat;
                  this.checkLeastOnePersonBoundWeChat();
                  this.noticeType = this.redisWarningForm.noticeType;
                  if (!this.isNotEmpty(this.redisWarningForm.wechatModal)) {
                    tableRedisWarningVue.selectTemplate();
                  }
                } else {
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = false;
                }
              }
            });
        } else {
          this.tableRedisDate = [];
          this.isEdit = false;
          this.isShowSearch = true;
          // 添加显示规则名称能输入
          this.isEditRuleName = true;
          this.showRuleName = false;
        }
      });
      this.modal = true;
      this.isNext = false;
      this.isPrevious = true;
    },
    // 根据监控指标 显示不同单位
    /****************************************************************/
    // 清空周期、连续周期、统计数值、关系符号
    emptyDate: function() {
      this.redisWarningForm.cycle = "";
      this.redisWarningForm.continousCycle = "";
      this.redisWarningForm.statisticsValue = "";
      this.redisWarningForm.relationshipSign = "";
      this.redisWarningForm.thresholdValue = "";
    },
    isNotEmpty: function(obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 判断状态
    judgeState: function() {
      let metrics = [];
      if (metrics.includes(this.redisWarningForm.monitorIndex)) {
        this.isShowField = false;
      } else {
        this.isShowField = true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex: function() {
      // 判断状态
      this.judgeState();
      tableRedisWarningVue.selectMonitorIndexDefault();
      this.unit = this.redisWarningForm.monitorIndex;
      for (let i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id === this.unit) {
          this.redisWarningForm.unit = this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableRedisWarningVue.selectTemplate();
      tableRedisWarningVue.emptyDate();
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault: function() {
      if (
        this.redisWarningForm.account == "" ||
        this.redisWarningForm.account == null
      ) {
        return;
      }
      tableRedisWarningVue.$api.alertRule
        .selectMonitorIndexDefault({
          monitorIndex: this.redisWarningForm.monitorIndex,
          monitorModule: this.monitorModule,
          cycle: this.redisWarningForm.cycle,
          continousCycle: this.redisWarningForm.continousCycle,
          statisticsValue: this.redisWarningForm.statisticsValue,
          relationshipSign: this.redisWarningForm.relationshipSign,
          accountId: this.redisWarningForm.account
        })
        .then(res => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableRedisWarningVue.isNotEmpty(this.redisWarningForm.cycle) &&
            tableRedisWarningVue.isNotEmpty(
              this.redisWarningForm.continousCycle
            ) &&
            tableRedisWarningVue.isNotEmpty(
              this.redisWarningForm.statisticsValue
            ) &&
            tableRedisWarningVue.isNotEmpty(
              this.redisWarningForm.relationshipSign
            ) &&
            this.redisWarningForm.id == 0
          ) {
            this.redisWarningForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },
    // 查询邮件模板
    /****************************************************************/
    selectTemplate: function() {
      tableRedisWarningVue.$api.briefReport
        .selectTemplate({
          monitorIndex: this.redisWarningForm.monitorIndex,
          relationshipSign: this.redisWarningForm.relationshipSign,
          monitorModule: this.monitorModule,
          noticeType: this.redisWarningForm.noticeType
        })
        .then(res => {
          this.redisWarningForm.wechatModal = res.data.briefReportBodyWechat;
          this.redisWarningForm.emailModal = res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectNoticeType: function() {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      for (let i = 0; i < this.redisWarningForm.noticeType.length; i++) {
        if (this.redisWarningForm.noticeType[i] === 0) {
          this.isShowEmail = true;
          this.noticeType = this.redisWarningForm.noticeType;
          tableRedisWarningVue.selectTemplate();
        }
        if (this.redisWarningForm.noticeType[i] === 1) {
          // this.isShowWeChat = true;
          this.noticeType = this.redisWarningForm.noticeType;
          this.checkLeastOnePersonBoundWeChat();
          tableRedisWarningVue.selectTemplate();
        } else if (this.redisWarningForm.noticeType[i] !== 1) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过微信
    checkLeastOnePersonBoundWeChat: function() {
      if (
        this.redisWarningForm.contactType == 0 &&
        this.redisWarningForm.userIdList.length == 0
      ) {
        return;
      }

      for (var i = 0; i < this.redisWarningForm.noticeType.length; i++) {
        if (this.redisWarningForm.noticeType[i] == 1) {
          var weChatDate = {
            contactType: this.redisWarningForm.contactType
          };
          // 联系方式为 -联系人-
          if (this.redisWarningForm.contactType == 0) {
            weChatDate.userIds = this.redisWarningForm.userIdList;
          }
          // 联系方式为 -联系人组-
          else if (this.redisWarningForm.contactType == 1) {
            weChatDate.contactGroupIds = this.redisWarningForm.contactGroupIds;
          }
          this.$api.userWeChat
            .checkLeastOnePersonBoundWeChat(weChatDate)
            .then(res => {
              if (res.data) {
                // 可以添加告警
                this.wechatWarningVisible = false;
                this.isAddOrEdit = false;
              } else {
                // 不可以添加微信告警
                this.wechatWarningVisible = true;
                this.isAddOrEdit = true;
              }
            });
        } else if (this.redisWarningForm.noticeType[i] != 1) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 联系人组
    listContactGroups: function() {
      this.$api.contactGroup
        .listContactGroupsByAccountId(
          "accountId",
          this.redisWarningForm.account
        )
        .then(res => {
          this.contactGroupIdList = res.data;
        });
    },
    // 切换联系人组
    changeContactGroupId: function() {
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换通知对象
    changeNotificationObject: function(val) {
      this.redisWarningForm.userIdList = [];
      this.redisWarningForm.notificationObject = val;
      for (
        var i = 0;
        i < this.redisWarningForm.notificationObject.length;
        i++
      ) {
        for (var j = 0; j < this.notificationObjectList.length; j++) {
          if (
            this.redisWarningForm.notificationObject[i] ==
            this.notificationObjectList[j].id
          ) {
            this.redisWarningForm.userIdList.push(
              this.notificationObjectList[j].userId
            ); //传值
          }
        }
      }
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换联系方式
    changeContactType: function() {
      this.checkLeastOnePersonBoundWeChat();
    },
    //点击查询 加载全部数据
    /***********************************************************************************/
    searchRedisDate: function() {
      if (
        this.redisWarningForm.account == "" ||
        this.redisWarningForm.account == null ||
        this.redisWarningForm.backupRegion == "" ||
        this.redisWarningForm.backupRegion == null
      ) {
        return;
      }
      this.modal_loadings = true;
      // 根据AccountId查询es列表
      tableRedisWarningVue.$api.DocDB.queryAwsDocDbClusters({
        regions: this.redisWarningForm.backupRegion,
        accountId: this.redisWarningForm.account,
        roleName: this.roleName
      }).then(res => {
        this.tableRedisDate = res.data;
        this.modal_loadings = false;
        this.monitorModule = res.data[0].monitorModule;
      });
    },

    /**************************************  查询  **************************************/
    // 查询监控指标
    searchMonitorIndex: function() {
      tableRedisWarningVue.$api.alertRule
        .searchMonitorIndex({
          monitorModule: this.monitorModule,
          accountId: this.redisWarningForm.account
        })
        .then(res => {
          this.monitorIndexList = res.data;
        });
    },
    // 查询通知对象
    queryContacts: function() {
      tableRedisWarningVue.$api.contact
        .queryContactsByAccountIdAndMonitorModule({
          monitorModule: this.monitorModule,
          accountId: this.redisWarningForm.account
        })
        .then(res => {
          this.notificationObjectList = res.data.contactList;
          this.redisWarningForm.notificationObject = res.data.defaultContactIds;
        });
    },
    // 查询报警方式
    alarmWay: function() {
      tableRedisWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then(res => {
          this.alarmWayList = res.data;
        });
    },
    // 查询报警延迟
    getAlarmDelay: function() {
      tableRedisWarningVue.$api.alertRule
        .alarmDelay("userName", getCookie(global.cookieName))
        .then(res => {
          this.alarmDelayList = res.data;
        });
    },
    // 查询监控时间段
    searchMonitorPeriod: function() {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then(res => {
          this.monitorPeriodList = res.data;
        });
    },
    // 周期
    changeCycle: function() {
      // 查询阈值
      tableRedisWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle: function() {
      // 查询阈值
      tableRedisWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue: function() {
      // 查询阈值
      tableRedisWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign: function() {
      // 查询阈值
      tableRedisWarningVue.selectMonitorIndexDefault();
      // 邮件模板
      tableRedisWarningVue.selectTemplate();
    },
    // 根据用户名查询Account列表
    getAccount: function() {
      // 清空表格
      this.tableRedisDate = [];
      tableRedisWarningVue.$api.account.queryAccounts("type", 0).then(res => {
        this.accountList = res.data;
      });
      // 查询方式
      tableRedisWarningVue.alarmWay();
      // 查询报警延时
      tableRedisWarningVue.getAlarmDelay();
      //监控时段
      tableRedisWarningVue.searchMonitorPeriod();
      // 监控模块查询关联的机器人列表
      tableRedisWarningVue.listEnterpriseWechatRobotsByMonitorModule();
    },
    // 监控模块查询关联的机器人列表
    listEnterpriseWechatRobotsByMonitorModule: function() {
      tableRedisWarningVue.$api.enterpriseWechatRobot
        .listEnterpriseWechatRobotsByMonitorModule({
          monitorModule: this.monitorModule
        })
        .then(res => {
          this.enterpriseWechatRobotIdsList = res.data;
        });
    },
    // 选择账户
    changeAccount: function() {
      if (
        this.redisWarningForm.account == "" ||
        this.redisWarningForm.account == null
      ) {
        return;
      }
      this.redisWarningForm.backupRegion = "";
      // 清空表格
      this.tableRedisDate = [];
      this.redisList = [];
      this.isShowSearch = true;
      this.isNextClick = true;
      tableRedisWarningVue.$api.account
        .queryAccountRegions("accountId", this.redisWarningForm.account)
        .then(res => {
          this.backupRegionList = res.data;
        });
      // 查询通知对象
      tableRedisWarningVue.queryContacts();
      // 查询联系人组
      tableRedisWarningVue.listContactGroups();
    },
    /***********存储区域**************************/
    selectBackupRegionAll() {
      this.redisWarningForm.backupRegion = [];
      if (this.singleBackupRegion) {
        this.backupRegionList.map(item => {
          this.redisWarningForm.backupRegion.push(item.name);
        });
      } else {
        this.redisWarningForm.backupRegion = [];
      }
    },
    // 切换存储区域
    changebackupRegion: function(val) {
      if (val.length === this.backupRegionList.length && val.length != 0) {
        this.singleBackupRegion = true;
      } else {
        this.singleBackupRegion = false;
      }
      // 表格数据为空、显示查询按钮、存储区域为空
      this.tableRedisDate = [];
      this.redisList = [];
      this.isShowSearch = true;
      this.isNextClick = true;
    },
    // 全选 单选
    /***********************************************************************************/
    // 单选
    selectChange(selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableRedisDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableRedisCopy = new Object();
        TableRedisCopy.id = this.selection[i].id;
        this.newTableRedisDateList.push(TableRedisCopy);
      }
      // 选了数据 可以点击下一步
      if (this.newTableRedisDateList.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 全选
    selectAll: function(selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableRedisDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        // 状态
        var TableRedisCopy = new Object();
        TableRedisCopy.id = this.selection[i].id;
        this.newTableRedisDateList.push(TableRedisCopy);
      }
      if (this.selection.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 创建添加或编辑报警
    /**********************************************************************************/
    ok: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var alertList = {
            alertRuleName: this.redisWarningForm.ruleName,
            monitorIndex: this.redisWarningForm.monitorIndex,
            cycle: this.redisWarningForm.cycle,
            continousCycle: this.redisWarningForm.continousCycle,
            statisticsValue: this.redisWarningForm.statisticsValue,
            relationshipSign: this.redisWarningForm.relationshipSign,
            accountId: this.redisWarningForm.account,
            monitorModule: this.monitorModule,
            noticeType: this.redisWarningForm.noticeType,
            unit: this.units,
            delay: this.redisWarningForm.alarmDelay,
            monitorPeriod: this.redisWarningForm.monitorPeriod,
            thresholdValue: this.redisWarningForm.thresholdValue,
            contactType: this.redisWarningForm.contactType
            // "enterpriseWechatRobotIds":this.redisWarningForm.enterpriseWechatRobotIds
          };

          // 如果联系方式是联系人 传通知对象
          if (this.redisWarningForm.contactType == 0) {
            alertList.contactIDs = this.redisWarningForm.notificationObject;
          }
          // 如果联系方式是联系人组 传联系人组
          else if (this.redisWarningForm.contactType == 1) {
            alertList.contactGroupIds = this.redisWarningForm.contactGroupIds;
          }

          if (this.redisWarningForm.id > 0) {
            alertList.id = this.redisWarningForm.id;
            // 根据后端返回 rolename 判断
            if (this.roleName == "集群") {
              alertList.docDbClusterDTOList = this.newTableRedisDateList;
            } else {
              alertList.docDbInstanceDTOList = this.newTableRedisDateList;
            }
            // 编辑告警
            this.addloading = true;
            tableRedisWarningVue.$api.alertRule
              .updateAlertRule(alertList)
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.redisWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("编辑成功");
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowSearch = false;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          } else {
            // 添加告警
            this.addloading = true;
            // alertList.resourceAwsCacheDTOList = this.newTableRedisDateList;
            if (this.roleName == "集群") {
              alertList.docDbClusterDTOList = this.newTableRedisDateList;
            } else {
              alertList.docDbInstanceDTOList = this.newTableRedisDateList;
            }
            tableRedisWarningVue.$api.alertRule
              .createAlertRule(alertList)
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  tableRedis.methods.showAll();
                  this.redisWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success("添加成功");
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          }
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          if (this.redisWarningForm.id > 0) {
            this.$Message.error("编辑失败");
          } else {
            this.$Message.error("添加失败");
          }
        }
      });
    },
    // 取消
    cancel: function(name) {
      this.wechatWarningVisible = false;
      this.isAddOrEdit = true;
      this.isShowSearch = false;
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.isNextClick = true;
      this.modal = false;
      this.$emit("on-cancel");
      this.redisWarningForm.notificationObject = [];
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
      // 清空表格
      this.tableRedisDate = [];
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/AddOrUpdateRedisWarning.vue